var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCap = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.796 26.263a14.334 14.334 0 0 0-1.67-.21v.02c-.069-.005-.139-.014-.206-.02-11.24-.774-21.456 6.91-23.728 17.886-.081.395-.168 1.282-.24 2.289a42.009 42.009 0 0 0-6.497 1.113c-.754.136-1.533.305-2.345.52-3.29.865-5.38 2.812-5.082 4.733.151.984 1.022 2.552 5.015 2.552.307 0 .636-.011.982-.028 3.538-.201 7.555-.76 10.746-1.278 2.443 2.001 5.029 3.976 9.066 4.132.533.02 1.067.028 1.6.028 8.105 0 15.953-2.221 16.389-2.345.971.022 1.923.033 2.84.033 4.863 0 8.9-.29 11.254-.853l.686-.164.123-.7c.162-.916.271-3.027.271-5.254-.006-13.086-9.378-20.956-19.203-22.454Zm-23.508 18.12c1.452-7.012 6.491-12.536 12.918-14.924-5.33 4.962-6.832 13.67-7.209 16.766a28.162 28.162 0 0 0-2.4-.173 49.212 49.212 0 0 0-3.488.031c.062-.785.123-1.435.179-1.7Zm-10.389 8.564c-2.987.173-3.735-.542-3.758-.69-.044-.282.556-1.101 2.022-1.771 4.886-1.588 7.683-.41 10.29 1.512-2.738.41-5.817.794-8.554.95Zm20.013 2.854c-3.523-.135-5.776-1.986-8.16-3.947-1.47-1.207-3.022-2.484-4.934-3.323a45.092 45.092 0 0 1 6.72-.311c7.335.195 16.422 3.99 20.839 6.047-3.311.732-9.01 1.746-14.465 1.534Zm24.259-2.337c-1.952.065-4.132.071-6.45.017-1.814-.935-10.893-5.456-19.593-6.954.466-3.708 2.808-16.989 12.516-18.354.374.006.751.017 1.128.046.542.036 1.086.098 1.63.177 2.477.447 4.56 1.65 6.199 3.615 5.162 6.185 4.793 18.054 4.57 21.453Zm6.527-.587c-1.158.217-2.644.378-4.369.486.243-3.767.486-14.892-4.333-21.75 5.064 3.286 8.853 8.952 8.853 17.105 0 1.805-.067 3.263-.15 4.159Z",
    fill: "currentColor"
  }))));
};
export { SvgCap as ReactComponent };